import { Id } from 'types';
import { Description } from './entity';

export enum TipoContoEnum {
  'SoloContiPersonali',
  'SoloContiVersamenti'
}

export type ContoLookup = Id & Description & { risorsaIDPredef?: number };
